export const UnsavedInheritanceChangesEvent = 'unsaved-inheritance-changes';
